import Cookies from 'cookies-js';
import { currentProfileIdService } from '../currentProfileIdService';

// Define the name of the cookie used to store user session data
var authCookieName = 'authToken';

// Define a mapping of HTTP response codes to paddl error codes that indicate an invalid session
var INVALID_SESSION_MAPPING = {
  UNAUTHORIZED: {
    key: 'paddl-error-code',
    value: 'ACCESS_DENIED'
  }
};

// Set a user session cookie with the provided data
export var setUserSessionCookie = function setUserSessionCookie(data, domain) {
  var isObjectWellFormed = function isObjectWellFormed(_ref) {
    var token = _ref.token,
      profile_id = _ref.profile_id,
      role = _ref.role;
    return token && profile_id && role;
  };
  if (!data || !isObjectWellFormed(data)) {
    throw new Error('setUserSessionCookie function expects a valid argument');
  }
  var config = {
    tokenKey: authCookieName,
    referrerKey: 'referrerCode',
    expires: 365 * 24 * 3600,
    path: '/',
    domain: domain
  };
  Cookies.set(authCookieName, JSON.stringify(data), config);
  return data;
};

// Retrieve the user session cookie or return null if not found
export var getUserSessionCookie = function getUserSessionCookie() {
  var sessionCookie = Cookies.get(authCookieName);
  if (!sessionCookie) {
    console.info('No user session cookie found');
    return null;
  }
  return sessionCookie;
};

// Get the user session cookie and return an object with the user's profile ID
export var getDecodedUserSessionCookie = function getDecodedUserSessionCookie() {
  return {
    profile_id: currentProfileIdService.getProfileIdCookie()
  };
};

// Delete the user session cookie and return a message indicating that the cookie has been deleted
export var deleteUserSessionCookie = function deleteUserSessionCookie(domain) {
  if (!getUserSessionCookie()) throw new Error("".concat(authCookieName, " key not found in Browser Cookies"));
  document.cookie = "".concat(authCookieName, "= ; expires = Thu, 28 Sept 1984 00:00:00 GMT; path=/; domain=").concat(domain, ";");
  return "".concat(authCookieName, " Cookie has been deleted from Browser Cookies");
};

// Check if the headers of an HTTP response indicate an invalid session
export var isSessionInvalid = function isSessionInvalid(headers) {
  var _INVALID_SESSION_MAPP = INVALID_SESSION_MAPPING.UNAUTHORIZED,
    key = _INVALID_SESSION_MAPP.key,
    value = _INVALID_SESSION_MAPP.value;
  return headers[key] === value;
};